function getHoursAndMinutes(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return { hours, minutes };
}

function getHHMM(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0'); // Adds leading zero if hours < 10
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Adds leading zero if minutes < 10
    return `${hours}:${minutes}`;
}

// function formatDateForLocale(date: string, locale = 'ru-RU', options = {}) {
//     const defaultOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
//     //@ts-ignore
//     return new Date(date).toLocaleString(locale, { ...defaultOptions, ...options });
// }

function formatDateForLocale(date: string, locale = 'ru-RU', options = {}) {
    const defaultOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC' // Отключает локальное смещение часового пояса
    };
    //@ts-ignore
    return new Date(date).toLocaleString(locale, { ...defaultOptions, ...options });
}

function formatDateDDMMYYYY(date: string, locale = 'ru-RU', options = {}) {
    const defaultOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    };
    //@ts-ignore
    return new Date(date).toLocaleString(locale, { ...defaultOptions, ...options });
}

export {
    getHoursAndMinutes,
    getHHMM,
    formatDateForLocale,
    formatDateDDMMYYYY,
}